import { Ahmedabad } from './India/Gujarat/Ahmedabad/Ahmedabad';
import { Rajkot } from './India/Gujarat/Rajkot';
import { Gandhinagar } from './India/Gujarat/Gandhinagar';
import { Surat } from './India/Gujarat/Surat';
import { Jamnagar } from './India/Gujarat/Jamnagar';
import { Vadodara } from './India/Gujarat/Vadodara';
import { Bhavnagar } from './India/Gujarat/Bhavnagar';
import { Junagadh } from './India/Gujarat/Junagadh';
import { Anand } from './India/Gujarat/Anand';
import { Surendranagar } from './India/Gujarat/Surendranagar';
import { Morbi } from './India/Gujarat/Morbi';
import { Gandhidham } from './India/Gujarat/Gandhidham';
import { Nadiad } from './India/Gujarat/Nadiad';
import { Bharuch } from './India/Gujarat/Bharuch';
import { Patan } from './India/Gujarat/Patan';
import { Porbandar } from './India/Gujarat/Porbandar';
import { Mehsana } from './India/Gujarat/Mehsana';
import { Bhuj } from './India/Gujarat/Bhuj';
import { Veraval } from './India/Gujarat/Veraval';
import { Amreli } from './India/Gujarat/Amreli';
import { Valsad } from './India/Gujarat/Valsad';
import { Vapi } from './India/Gujarat/Vapi';
import { Himatnagar } from './India/Gujarat/Himatnagar';
import { Kalol } from './India/Gujarat/Kalol';
import { Botad } from './India/Gujarat/Botad';
import { Jetpur } from './India/Gujarat/Jetpur';
import { Gondal } from './India/Gujarat/Gondal';
import { Godhra } from './India/Gujarat/Godhra';
import { Palanpur } from './India/Gujarat/Palanpur';
import { Deesa } from './India/Gujarat/Deesa';

export const drawerContent = {
    india: {
        title: "Gujarat"
    },
    Ahmedabad,
    Rajkot,
    Gandhinagar,
    Surat,
    Jamnagar,
    Vadodara,
    Bhavnagar,
    Junagadh,
    Anand,
    Surendranagar,
    Morbi,
    Gandhidham,
    Nadiad,
    Bharuch,
    Patan,
    Porbandar,
    Mehsana,
    Bhuj,
    Veraval,
    Amreli,
    Valsad,
    Vapi,
    Himatnagar,
    Kalol,
    Botad,
    Jetpur,
    Gondal,
    Godhra,
    Palanpur,
    Deesa,
};
